import(/* webpackMode: "eager", webpackExports: ["LoginClientPage"] */ "/opt/atlassian/pipelines/agent/build/apps/sales/app/(public)/login/client.tsx");
